import React from 'react';
import styles from '../Operations.module.css';

interface EEComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

const EE: EEComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>
      <div className={styles.sectionContent}>
        <strong>Employee Engagement Definition:</strong>
        <br />
        Employee Engagement is a measurement of the emotional commitment associates have to your store and your goals. The Employee Engagement score is determined by the average rating of all responses to the survey on a 5-point scale.
        <br /><br />
        The store can administer the survey process multiple times in a year and the highest score will be used.
        <br /><br />
        Minimum requirement is 5 surveys completed per monthly survey window. Stores must meet or exceed the target once in the calendar year to achieve Platinum or Pinnacle status.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>
      <div className={styles.sectionContent}>
        Find more information on:{' '}
        <a
          href="https://acenet.aceservices.com/awor/manage-and-coach/employee-engagement-survey"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          Acenet &gt; Manage My Store &gt; People Management &gt; Customer and Employee Engagement &gt; Employee Experience
        </a>.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>
      <div className={styles.sectionContent}>
        <strong>Platinum</strong> - Complete at least 1 employee engagement survey event per year and achieve or exceed a <strong>3.75/5 – 4.249/5</strong> engagement score. (Min 5 surveys).
        <br /><br />
        <strong>Pinnacle -</strong> Complete at least 1 employee engagement survey event per year and achieve or exceed a <strong>4.25/5</strong> engagement score. (Min 5 surveys).
        <br /><br />
        <strong><u>Drill Down</u></strong>
        <br />
        To drill down into data login to the{' '}
        <a
          href="https://acehardware.medallia.com/sso/acehardware/idpSelect.do"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          Helpful Experience/Medallia Dashboard
        </a>.
        <br /><br />
       Use the new Dashboard to take a deeper dive into your EE Surveys.
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>
      <div className={styles.sectionContent}>
        <ol style={{ marginTop: 0, paddingLeft: '2rem' }}>
          <li>Review your survey results and Action Plan that has been generated and sent to your email address.</li>
          <li>Work through the Action plan and take related Ace Learning Place Employee Engagement Training.</li>
        </ol>
      </div>
    </div>
  );
};

EE.title = 'Employee Engagement';
EE.actionTitle = 'Review Medallia Dashboard';
EE.actionHyperlink = 'https://acehardware.medallia.com/sso/acehardware/idpSelect.do';
export default EE;

